const maps = document.querySelectorAll(".map");

const bringRegionToFront = (region: Element) => {
    const targetToMove = region.closest("g") || region;

    const parentSvg = targetToMove.parentNode;

    if (parentSvg && parentSvg.lastElementChild !== targetToMove) {
        parentSvg.append(targetToMove);
    }
};

maps.forEach((map) => {
    const regions = map.querySelectorAll(".region");

    regions.forEach((region) => {
        const locations = map.querySelectorAll(`.location-entry[data-location-region="${region.id}"]`);

        region.addEventListener("mouseenter", () => {
            bringRegionToFront(region);
            locations.forEach((location) => location.classList.add("is-active"));
        });

        region.addEventListener("mouseleave", () => {
            locations.forEach((location) => location.classList.remove("is-active"));
        });
    });

    const locations = <NodeListOf<HTMLElement>>map.querySelectorAll(".location-entry");

    locations.forEach((location) => {
        const region = location.dataset.locationRegion
            ? map.querySelector(`#${location.dataset.locationRegion}`)
            : null;
        if (region) {
            location.addEventListener("mouseenter", () => {
                bringRegionToFront(region);
                region.classList.add("is-active");
            });
            location.addEventListener("mouseleave", () => {
                region.classList.remove("is-active");
            });
        }
    });
});
